import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { fetchRequest } from '@tk/utilities/tk.fetch';

export default class TCSessionvar extends TKCustomElementFactory {
    inputs: NodeListOf<HTMLInputElement | HTMLSelectElement>;
    oc?: string;
    reloadPage: boolean;

    constructor() {
        super();

        this.oc = this.getAttribute('data-tk-url') || undefined;
        this.inputs = this.querySelectorAll('input, select') || undefined;
        this.reloadPage = this.hasAttribute('data-tk-reload-page');
    }

    connectedCallback(): void {
        if (this.inputs.length === 0 || !this.oc) return;

        this.registerListener();
    }

    registerListener(): void {
        [...this.inputs].forEach((input) => {
            const action = this.sendRequest.bind(this, input);
            const event = input instanceof HTMLInputElement ? 'focusout' : 'change';

            this.pushListener({
                event,
                element: input,
                action,
            });
        });
    }

    sendRequest(input: HTMLInputElement | HTMLSelectElement) {
        const data = {
            value: input.value,
        };

        fetchRequest({
            requestURL: this.oc!,
            resolveHandler: this.logResult.bind(this),
            payload: data,
        });
    }

    logResult(reponse:TKResponse<{[key: string]: string}>) {
        console.log(reponse.dataAsJson);

        if (this.reloadPage) location.reload()
    }
}